import { makeAutoObservable, runInAction } from "mobx";
import agent from "../api/agent";
import { IRAMStation, IRAMSystem } from "../models/ram";

export class RamStore {
    loadingTable = false;
    loadingDownload = false;
    list: IRAMSystem[] | IRAMStation[] = []

    constructor() {
        makeAutoObservable(this)
    }

    clearList = () => {
        this.list = []
    }
    
    // Data Fetching
    downloadExcel = async (id: number | null) => {
        if (!id) throw new Error('Id is not found')
        
        this.loadingDownload = true
        try {
            await agent.RAM.download(id)
        } catch (error) {
            throw error
        } finally {
            runInAction(() => this.loadingDownload = false)
        }
    }
    getSystem = async (systemId?: number) => {
        if (!systemId) throw new Error('System Id is not found');

        this.loadingTable = true
        try {
            const res = await agent.RAM.getSystem(String(systemId))

            runInAction(() => this.list = res)
        } catch (error) {
            throw error
        } finally {
            runInAction(() => this.loadingTable = false)
        }
    }
    getStation = async (stationId?: number) => {
        if (!stationId) throw new Error('Station Id is not found')
        
        this.loadingTable = true
        try {
            const res = await agent.RAM.getStation(String(stationId))

            runInAction(() => this.list = res)
        } catch (error) {
            throw error
        } finally {
            runInAction(() => this.loadingTable = false)
        }
    }
}